import { useEffect, useState } from 'react';
import Thread from '../thread/Thread';
import { cvToJSON, hexToCV } from '@stacks/transactions';

const Attachments = ({ attachmentData, setReplyOpen, authorPrincipal, userSettings,
    playList, setPlayList, openMediaPlayer, setOpenMediaPlayer,
    selectedChimeTx, setSelectedChimeTx, mediaCurrentTime, setMediaCurrentTime
}) => {
    const [attachmentsData, setAttachmentsData] = useState([]);

    useEffect(() => {
        attachmentData.map(({ tx_id, contract_log: { value: { hex } } }) => {
            const { value } = cvToJSON(hexToCV(hex));
            if ((value['attachment-uri'] && value['attachment-uri'].value !== null) || (value['thumbnail-uri'] && value['thumbnail-uri'].value !== null)) {
                setAttachmentsData(attachmentsData => [...attachmentsData, { base: tx_id, hex: hex }])
            }
            return true;
        })
    }, [attachmentData])

    return (
        <>
            {attachmentsData && attachmentsData.map(({ base, hex }, i) => {
                return <Thread baseTxId={base} hex={hex} setReplyOpen={setReplyOpen} profilePrincipal={authorPrincipal} index={i} key={i} userSettings={userSettings}
                    playList={playList} setPlayList={setPlayList} openMediaPlayer={openMediaPlayer} setOpenMediaPlayer={setOpenMediaPlayer}
                    selectedChimeTx={selectedChimeTx} setSelectedChimeTx={setSelectedChimeTx} mediaCurrentTime={mediaCurrentTime} setMediaCurrentTime={setMediaCurrentTime}
                />
            })}
        </>
    )
}

export default Attachments;